import Cookies from 'js-cookie'
import Backend from './backend'
import GlobalData from './global_data'

export default {
  logout (callSource) {
    this.doLogout(callSource)
  },
  doLogout (callSource) {
    Backend.clearGlobalCache()
    GlobalData.clearTabShareData()
    callSource.$store.commit('main/setLogined', false)
    Cookies.remove('sid')
    localStorage.clear()
    callSource.$router.push('/login')
  }
}
